export enum CertificateStatus {
  PENDING = "PENDING",
  REFUSED = "REFUSED",
  VALIDATED = "VALIDATED",
}
